/**
 * Convert base64 to file
 * @param {string} base64 - The base64 string
 * @param {string} filename - The filename
 * @returns {File} - The file
 */

/**
 * Convert file to base64
 * @param {File} file - The file
 * @returns {Promise<string>} - The base64 string
 */
export function useFiles() {
    const base64ToFile = (base64, filename) => {
        const arr = base64.split(',')
        const mime = arr[0].match(/:(.*?);/)[1]
        const bstr = atob(arr[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)
    
        while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
        }
    
        return new File([u8arr], filename, { type: mime })
    }

    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => resolve(reader.result)
            reader.onerror = error => reject(error)
        })
    }

    return {
        base64ToFile,
        fileToBase64
    }
}